import { util } from 'echarts';
import { ThemeParser } from '../../../core/theme';

function parseAxisPointer(option: Parameters<ThemeParser>[0]) {
  const defaultAxisPointer = {
    dvAutoHide: true,
    dvHideDelay: 0,
    dvShowOnlyWhenRenderingContent: true,
    dvShowOutOfGrid: true,
    dvHideWhenClickInGrid: false
  };
  option.axisPointer = util.merge(util.clone(defaultAxisPointer), option.axisPointer || {}, true);
}

export function axisPointerThemeParse(...args: Parameters<ThemeParser>) {
  const [option] = args;

  parseAxisPointer(option);
}
